import React, { useMemo } from 'react';
import { Grid } from '@guestyci/arc';
import { useBreakpoint } from '../../utils/useBreakpoint';
import AuthImageBlock from './AuthImageBlock';

const LoginPageLayout = ({ children, showStepper = false }) => {
  const isDesktop = useBreakpoint('lg');

  const gridStyle = useMemo(() => {
    if (!isDesktop) return { gridAutoRows: 'min-content' };
    return showStepper
      ? { gridTemplateRows: 'auto 1fr' }
      : { gridTemplateRows: '1fr' };
  }, [isDesktop, showStepper]);

  return (
    <Grid
      columns={{ xs: 1, md: 1, lg: 2 }}
      gap={{ xs: 4, md: 4, lg: 0 }}
      className="gst-flex-1 gst-bg-white gst-px-5 lg:gst-px-16"
      style={gridStyle}
    >
      <AuthImageBlock showStepper={showStepper} />
      {children}
    </Grid>
  );
};

export default LoginPageLayout;
